import { initProfileForm } from '../components/forms/initProfileForm';

window.addEventListener('DOMContentLoaded', function () {
    initProfileForm();
});
